export default {
      id: "ic_ticket_filter_down-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_ticket_filter_down-usage",
      toString: function () {
        return this.url;
      }
    }